module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-flash"
  }, [(!_vm.datas.length) ? _c('skeleton') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ushk-flash_list",
    attrs: {
      "id": "J_flash_list"
    }
  }, [(_vm.datas.length) ? _c('ushk-message-group', {
    attrs: {
      "datas": _vm.renderDatas
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ushk-more"
  }, [(_vm.datas.length) ? _c('a', {
    staticClass: "ushk-more__btn",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.lower
    }
  }, [_c('i', {
    staticClass: "ushk-icon ushk-icon_expand"
  }), _vm._v("点击加载更多")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e9f62a0","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/FlashList.vue
// module id = wz0z
// module chunks = 1